import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContainerReloadService {
  public reloadContainerData = new BehaviorSubject<boolean>(false);
}
